import { createSelector } from 'reselect';

import { getBuilder } from './getBuilder';

export const getSceneLoaded = createSelector(
  getBuilder,
  builder => builder.sceneLoaded
);
